import { useState } from "react";
import {
  RequestUpdateUserRequest,
  UsersUpdateUserPostRequest,
  UsersApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdateUser = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateUser = async (req: RequestUpdateUserRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersUpdateUserPostRequest = {
        req,
      };

      const api = new UsersApi(config);
      const response = await api.usersUpdateUserPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateUser, error, isLoading };
};
